export default __webpack_public_path__ + "static/px7-2a3338abe7974e76fb419b4125e118be.jpg";